import PropTypes from 'prop-types'
import Link from 'next/link'
import classNames from 'classnames'

import Icon from '../../icon'
import Form from '../../form'
import Modal from '../../modal'
import Typography from '../../typography'

import { CLOSED } from '../constants'
import { useWebinarSusbcription } from './hooks'
import { useBreakpoint } from '../../../../hooks/breakpoint'

import ArrowRight from '../../icon/arrow-right.svg'

const Action = ({ webinar, ...attrs }) => {
  const hasForm = webinar && webinar.registrationForm

  const breakpoint = useBreakpoint()
  const { suscribe, modal, form } = useWebinarSusbcription(webinar)

  const handleClick = (event) => {
    return suscribe(event)
  }

  return <>
    <Link
      href={`/webinars/${webinar.id}/${webinar.meta.slug}`}>
      <a
        className={
          classNames([
            'self-end',
            'block',
            'w-full',
            'flex',
            'flex-row',
            'justify-center',
            'text-center',
            'bg-green-500',
            'text-white',
            'py-3',
            'px-6',
            'hover:bg-green-400',
            'active:bg-green-600'
          ])
        }
        style={{
          borderRadius: '0 1.5rem 1.5rem 1.5rem'
        }}
        onClick={hasForm ? handleClick : () => {}}>
        {
          webinar.transmissionState === CLOSED
            ? <>Ver ahora</>
            : <>Únete ahora</>
        }
        <Icon
          className={'ml-2'}
          svg={ArrowRight}
          width={24}
          height={24} />
      </a>
    </Link>
    {
      hasForm
        ? <Modal
          open={modal.isOpen}
          onClose={() => modal.setIsOpen(false)}>
          <div
            className={'w-screen p-6 md:p-8 bg-white'}
            style={{
              maxWidth: '420px'
            }}>
            <Typography
              size={breakpoint.mdAndUp ? 'four' : 'three'}
              weight={'bold'}
              className={'mb-4 text-green-500'}>
              { webinar.registrationTitle || 'Inscríbete dejando tus datos'}
            </Typography>
            <Form
              form={webinar.registrationForm}
              pageId={webinar.id}
              onSuccess={form.onSuccess} />
          </div>
        </Modal>
        : null
    }
  </>
}

Action.propTypes = {
  webinar: PropTypes.object
}

export default Action
